export default {
  namespaced: true,

  state: {
    hasData: false,
    hasError: false,
    isLoading: false,
    currentMonth: {},
    selectedMonth: {},
    updateKey: 0,
  },

  mutations: {
    IS_LOADING(state, bool) {
      state.isLoading = bool;
    },

    HAS_DATA(state, bool) {
      state.hasData = bool;
    },

    HAS_ERROR(state, bool) {
      state.hasError = bool;
    },

    UPDATE_CURRENT_MONTH(state, usage) {
      state.currentMonth = usage;
    },

    UPDATE_SELECTED_MONTH(state, usage) {
      state.selectedMonth = usage;
    },

    UPDATE_KEY(state) {
      state.updateKey += 1;
    },
  },

  actions: {
    UPDATE_CURRENT_MONTH(context, usage) {
      context.commit('UPDATE_CURRENT_MONTH', usage);
    },

    UPDATE_SELECTED_MONTH(context, usage) {
      context.commit('UPDATE_SELECTED_MONTH', usage);
    },
  }
}
